import styles from './styles.less';
 import cx from 'classnames';
 import React from 'react';

function Hero(props) {
    const classes = cx(styles.root, props.className);
    props = props.data;

    return (
        <div className={ classes }>
            { props.content.map((item, i) => {
                let image = (
                    <img
                        alt={ item.title }
                        src={ item.image }
                    />
                );
                let linkImage = (
                    <a
                        key={ i }
                        href={ item.link }>
                        { image }
                    </a>
                );

                return (item.link) ? linkImage : image;
            } ) }
        </div>
    );
}

export default Hero;



// WEBPACK FOOTER //
// ./src/client/components/hero/index.js